import {
  publicHttpClient,
  type AxiosRequestConfig,
} from '@ahm/api-wrappers-core';
import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import { apiRoutes } from './api-routes';
import type { SoloMealItem } from './use-get-solomeal-item';

export interface GetTrendingItemParams {
  lat?: number;
  lng?: number;
  limit?: number;
  skip?: number;
}

export interface TrendingItemsResponse {
  trending_items: SoloMealItem[];
}

export const getTrendingItemFn = async (
  params: GetTrendingItemParams,
  config: AxiosRequestConfig = {}
): Promise<TrendingItemsResponse> => {
  const response = await publicHttpClient.get<TrendingItemsResponse>(
    apiRoutes.ahafood.web_view.trending_items,
    {
      params,
      ...config,
    }
  );

  return response?.data;
};

export const useGetTrendingItem = (
  params: GetTrendingItemParams,
  opts?: Omit<
    UseQueryOptions<TrendingItemsResponse, Error>,
    'queryKey' | 'queryFn'
  >
) => {
  return useQuery<TrendingItemsResponse, Error>({
    queryKey: [apiRoutes.ahafood.web_view.trending_items, params],
    queryFn: () => getTrendingItemFn(params),
    ...opts,
  });
};
